<div class="detail-skeleton">
  <div class="detail-skeleton__header-card">
    <div class="detail-skeleton__header-left">
      <p-skeleton width="64px" height="64px" borderRadius="8px" />
      <div class="detail-skeleton__header-info">
        <p-skeleton width="200px" height="28px" borderRadius="4px" />
        <p-skeleton width="120px" height="16px" borderRadius="4px" />
      </div>
    </div>
    <div class="detail-skeleton__header-right">
      <p-skeleton width="96px" height="36px" borderRadius="6px" />
      <p-skeleton shape="circle" size="36px" />
    </div>
  </div>

  <div class="detail-skeleton__body-card">
    <div class="detail-skeleton__tabs">
      @for (i of Array(3).fill(0); track $index) {
        <p-skeleton width="72px" height="20px" borderRadius="4px" />
      }
    </div>

    <div class="detail-skeleton__form">
      @for (i of Array(8).fill(0); track $index) {
        <div class="detail-skeleton__field">
          <p-skeleton width="80px" height="14px" borderRadius="4px" />
          <p-skeleton height="40px" borderRadius="6px" />
        </div>
      }
    </div>
  </div>
</div>
